import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { LandingPage, LandingPageProviders } from '@/pages/landing';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <LandingPageProviders>
      <LandingPage />
    </LandingPageProviders>
  </StrictMode>,
);
